var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGarden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 15.9444C10.6649 15.064 9.86133 13.5716 9.86133 11.9722C9.86133 10.3728 10.6649 8.88041 12.0002 8C13.3355 8.88041 14.1391 10.3728 14.1391 11.9722C14.1391 13.5716 13.3355 15.064 12.0002 15.9444Z",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0124 10.9403C15.0557 10.3582 16.2638 10.1423 17.4441 10.327C17.7608 11.8618 17.2986 13.4541 16.2093 14.5808C15.1199 15.7075 13.5442 16.2232 11.9995 15.9584C10.4548 16.2232 8.8791 15.7075 7.78976 14.5808C6.70043 13.4541 6.23822 11.8619 6.55492 10.327C7.7352 10.1423 8.94331 10.3583 9.98656 10.9403",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarden);
export default __webpack_public_path__ + "static/media/garden.fe0e3d7692960ee18861dd5d99c14c4c.svg";
export { ForwardRef as ReactComponent };